/* ACS 2026-10-09 (Claude refresh): catalog toolbar behaviour (collections + search).
   - View switch Tiles / Compact / List: <html data-acs-view>, remembered in localStorage (acs_catalog_view).
   - Per page 24 / 48 / 96: full page load to ?view=per24 / per96 (comics-per… on comics collections), remembered
     (acs_catalog_pp); a remembered size is swapped in without a redirect by the script after the grid in
     sections/main-collection-product-grid.liquid (<html data-acs-pp-view>, address stays clean, ACS 2026-10-10).
   - Phones: Filter opens the theme's filter drawer, Sort re-renders the grid like the theme's own sort.
   - Back from a product: the customer's place in the grid comes back (sessionStorage acs_catalog_place), after the
     in-stock swap when one is loading (<html data-acs-swapping>, event acs:instock:swapped).
   - In stock only (Oct 9): filter.v.availability is the page's own rule, not a shopper filter, so it is not counted.
   - ACS 2026-10-10 (round 3): the Filter count and Sort box are synced after the address is updated (a render from
     the cache fires acs:facets:rendered before assets/facets.js writes the new address). On in-stock collections
     (<html data-acs-instock>, /collections/…) links in the grid and filters drop filter.v.availability (the clean
     address lists in stock by itself; assets/facets.js adds it back on every render), and page links re-render the
     grid in place (FacetFiltersForm.renderPage: one section request, same in-stock list, clean address). */
(function () {
  if (window.acsCatalogReady) return;
  window.acsCatalogReady = true;

  var VIEW_KEY = 'acs_catalog_view';
  var PP_KEY = 'acs_catalog_pp';
  var PLACE_KEY = 'acs_catalog_place';
  var VIEWS = /^(tiles|compact|list)$/;

  function store(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function currentView() {
    var v = document.documentElement.getAttribute('data-acs-view');
    return VIEWS.test(v || '') ? v : 'compact';
  }

  function syncViewButtons() {
    var v = currentView();
    document.querySelectorAll('[data-acs-set-view]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-acs-set-view') === v ? 'true' : 'false');
    });
  }

  function setView(v) {
    if (!VIEWS.test(v)) return;
    document.documentElement.setAttribute('data-acs-view', v);
    store(VIEW_KEY, v);
    syncViewButtons();
  }

  function cleanParams(params) {
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (key) {
      if (params.has(key) && params.getAll(key).every(function (x) { return x === ''; })) params.delete(key);
    });
    return params;
  }

  function goPerPage(n) {
    var root = document.querySelector('[data-acs-catalog]');
    var prefix = (root && root.getAttribute('data-acs-prefix')) || 'per';
    store(PP_KEY, String(n));
    var params = cleanParams(new URLSearchParams(window.location.search));
    params.delete('page');
    if (n === 48) params.delete('view');
    else params.set('view', prefix + n);
    var qs = params.toString();
    window.location.assign(window.location.pathname + (qs ? '?' + qs : ''));
  }

  function filterCount() {
    var params = new URLSearchParams(window.location.search);
    var n = 0;
    var price = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0 || value === '' || key === 'filter.v.availability') return;
      if (key.indexOf('filter.v.price.') === 0) { price = true; return; }
      n += 1;
    });
    return n + (price ? 1 : 0);
  }

  function syncFromUrl() {
    var n = filterCount();
    document.querySelectorAll('[data-acs-filter-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
    var sort = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('select[data-acs-sort]').forEach(function (sel) {
      var want = sort || sel.getAttribute('data-default') || '';
      if (want && sel.value !== want && sel.querySelector('option[value="' + want.replace(/"/g, '') + '"]')) sel.value = want;
    });
  }

  // In-stock collections (also /ja/collections/…): the clean address already lists in stock (main-collection-product-grid).
  function instockCollection() {
    return document.documentElement.hasAttribute('data-acs-instock') && window.location.pathname.indexOf('/collections/') > -1;
  }

  function cleanHref(href) {
    var u = new URL(href, window.location.origin);
    u.searchParams.delete('filter.v.availability');
    if (u.searchParams.get('page') === '1') u.searchParams.delete('page');
    var qs = u.searchParams.toString();
    return u.pathname + (qs ? '?' + qs : '') + u.hash;
  }

  function cleanLinks() {
    if (!instockCollection()) return;
    document.querySelectorAll(
      '#ProductGridContainer a[href*="filter.v.availability"], #main-collection-filters a[href*="filter.v.availability"]'
    ).forEach(function (a) {
      try { a.setAttribute('href', cleanHref(a.getAttribute('href'))); } catch (e) {}
    });
  }

  var pageFocus = false;
  function toGridTop() {
    var g = document.getElementById('ProductGridContainer');
    if (!g) return;
    var off = 8;
    var h = document.querySelector('.shopify-section-header-sticky');
    if (h && !h.classList.contains('shopify-section-header-hidden')) off += h.offsetHeight;
    var bar = document.querySelector('[data-acs-bar]');
    if (bar && getComputedStyle(bar).position === 'sticky') off += bar.offsetHeight;
    var y = Math.max(0, Math.round(g.getBoundingClientRect().top + window.scrollY - off));
    if (window.scrollY > y) window.scrollTo(0, y);
  }

  function drawerSummary() {
    return document.querySelector('menu-drawer.mobile-facets__wrapper > details > summary');
  }

  var filterOpener = null;
  function openFilters(btn) {
    var summary = drawerSummary();
    if (!summary) return;
    filterOpener = btn;
    summary.click();
    var details = summary.parentNode;
    setTimeout(function () {
      var close = details.querySelector('.mobile-facets__close');
      if (close && details.hasAttribute('open')) close.focus();
    }, 60);
  }

  function sortBy(value) {
    var params = cleanParams(new URLSearchParams(window.location.search));
    params.set('sort_by', value);
    params.delete('page');
    var grid = document.getElementById('product-grid');
    if (typeof FacetFiltersForm !== 'undefined' && grid && grid.dataset.id && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params.toString());
    } else {
      window.location.assign(window.location.pathname + '?' + params.toString());
    }
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var viewBtn = t.closest('[data-acs-set-view]');
    if (viewBtn) { setView(viewBtn.getAttribute('data-acs-set-view')); return; }
    var ppBtn = t.closest('[data-acs-pp]');
    if (ppBtn) {
      if (ppBtn.getAttribute('aria-pressed') === 'true') { store(PP_KEY, ppBtn.getAttribute('data-acs-pp')); return; }
      goPerPage(parseInt(ppBtn.getAttribute('data-acs-pp'), 10));
      return;
    }
    var filterBtn = t.closest('[data-acs-open-filters]');
    if (filterBtn) { openFilters(filterBtn); return; }
    var pageLink = t.closest('#ProductGridContainer .pagination a[href], #ProductGridContainer .acs-more-next a[href]');
    if (
      pageLink && instockCollection() && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey &&
      !event.altKey && typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage &&
      FacetFiltersForm.getSections().length
    ) {
      var target = new URL(pageLink.getAttribute('href'), window.location.origin);
      if (target.pathname === window.location.pathname) {
        event.preventDefault();
        pageFocus = true;
        FacetFiltersForm.renderPage(target.searchParams.toString());
        toGridTop();
        return;
      }
    }
    var link = t.closest('a[href*="/products/"]');
    if (link && link.closest('#ProductGridContainer')) {
      try {
        sessionStorage.setItem(PLACE_KEY, JSON.stringify({ href: window.location.href, y: Math.round(window.scrollY), t: Date.now() }));
      } catch (e) {}
    }
  });

  document.addEventListener('change', function (event) {
    var sel = event.target && event.target.closest && event.target.closest('select[data-acs-sort]');
    if (sel) sortBy(sel.value);
  });

  // After the address update (renderPage writes it right after a render from the cache).
  document.addEventListener('acs:facets:rendered', function () {
    cleanLinks();
    setTimeout(syncFromUrl, 0);
    if (pageFocus) {
      pageFocus = false;
      var g = document.getElementById('ProductGridContainer');
      if (g) {
        if (!g.hasAttribute('tabindex')) g.setAttribute('tabindex', '-1');
        try { g.focus({ preventScroll: true }); } catch (e) {}
      }
    }
  });
  window.addEventListener('popstate', function () { setTimeout(syncFromUrl, 0); });

  // Drawer closed after we opened it: give focus back to our Filter button (the theme's own button is hidden).
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (!filterOpener || !d || !d.matches || !d.matches('.mobile-facets__disclosure') || d.hasAttribute('open')) return;
    var btn = filterOpener;
    filterOpener = null;
    setTimeout(function () { if (document.contains(btn)) btn.focus(); }, 0);
  }, true);

  // Keep the place in the grid when coming back from a product (full reload; bfcache keeps it by itself).
  function navType() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type;
      if (performance.navigation) return performance.navigation.type === 2 ? 'back_forward' : 'other';
    } catch (e) {}
    return 'other';
  }
  function restorePlace() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(PLACE_KEY) || 'null'); } catch (e) {}
    if (!saved || saved.href !== window.location.href || Date.now() - saved.t > 2 * 3600 * 1000) return;
    if (navType() !== 'back_forward') return;
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      container.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
    }
    var y = saved.y;
    var go = function () { if (Math.abs(window.scrollY - y) > 4) window.scrollTo(0, y); };
    window.requestAnimationFrame(go);
    setTimeout(go, 250);
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) return;
    if (document.documentElement.hasAttribute('data-acs-swapping')) {
      document.addEventListener('acs:instock:swapped', function () { restorePlace(); }, { once: true });
    } else {
      restorePlace();
    }
  });

  function init() {
    syncViewButtons();
    syncFromUrl();
    // Not while the in-stock swap is loading: a failed swap keeps its links to the in-stock address.
    if (!document.documentElement.hasAttribute('data-acs-swapping')) cleanLinks();
    var summary = drawerSummary();
    if (summary && document.querySelector('[data-acs-open-filters]')) summary.setAttribute('tabindex', '-1');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
